'use strict';

const _ = require('underscore');
const Base = require('components/Base/Base');
const Events = require('constants/Events');
const Constants = require('constants/Constants');

require('./IndexPurpleCard.less');

const Selectors = {
    el: '.IndexPurpleCard',
    card: '.IndexPurpleCard-card',
    trigger: '.IndexPurpleCard-trigger',
    cardItem1: '.IndexPurpleCard-cardItem_1',
    cardItem2: '.IndexPurpleCard-cardItem_2',
    tailoredBlock: '.IndexTailored'
};

const BindFunctions = [
    'onScroll',
    '_initVariables',
    'onResize'
];

const AnimationStates = {
    before: 'before',
    inProgress: 'in-progress',
    bottomInProgressDown: 'bottom-in-progress-down',
    bottomInProgrerssUp: 'bottom-in-progress-up'
};

module.exports = Base.extend({

    el: Selectors.el,

    initialize: function (options = {}) {
        Base.prototype.initialize.call(this, options);
        _.bindAll(this, BindFunctions);

        app.vent.on(Events.common.scroll, this.onScroll);

        setTimeout(() => {
            this._initVariables();

            if (app.isPhoneLayout()) {
                return;
            }
            this.onResize.__throttled = _.throttle(this.onResize, 50);
            app.vent.on(Events.common.pageLoaded, this.onResize);
            app.vent.on(Events.home.hero.sequenceEnded, this.onResize);
            app.vent.on(Events.common.resizeEnded, this.onResize);
            this.onResize();
        }, 1000);

        app.vent.on(Events.common.pageLoaded, () => {
            setTimeout(this.onResize, 1000);
        });
    },

    _initVariables: function () {
        this.$triggerElement = this.$(Selectors.trigger);
        this.$card = this.$(Selectors.card);
        this.$cardItem1 = this.$(Selectors.cardItem1);
        this.$cardItem2 = this.$(Selectors.cardItem2);
        this.startAnimationPoint = this.$triggerElement.offset().top;
        this.endAnimationPoint = this.$triggerElement.offset().top + window.app.els.$window.height();
        this.progress = 0;
        this.percentage = 0;
        // css end parameters
        this.startRotate = 59;
        this.maxRotate = 95;
        this.startScale = 1;
        this.maxScale = 10;
        this.maxTranslateX = -100; // in vw
        this.animationState = AnimationStates.before;
        this.prevScroll = 0;
        this.secondCardShown = false;

        if (window.matchMedia('(min-width: 1440px)').matches) {
            this.maxTranslateX = -70; // in vw
        }

        if (window.matchMedia('(min-width: 1920px)').matches) {
            this.maxTranslateX = -50; // in vw
        }

        if (window.matchMedia('(min-width: 2400px)').matches) {
            this.maxTranslateX = -30; // in vw
        }

        // css const values
        this.skew = 'skew(0deg, -26deg)';
    },

    onResize: function () {
        this.startAnimationPoint = this.$triggerElement.offset().top;
        this.endAnimationPoint = this.$triggerElement.offset().top + window.app.sizes.windowHeight;
        this.progressCoef = 1 / (this.endAnimationPoint - this.startAnimationPoint);

        this.maxTranslateX = -100; // in vw

        if (window.matchMedia('(min-width: 1440px)').matches) {
            this.maxTranslateX = -70; // in vw
        }

        if (window.matchMedia('(min-width: 1920px)').matches) {
            this.maxTranslateX = -50; // in vw
        }

        if (window.matchMedia('(min-width: 2400px)').matches) {
            this.maxTranslateX = -30; // in vw
        }

        this.onScroll(app.els.$window.scrollTop());
    },

    onScroll: function (scrollTop) {
        const currentScroll = scrollTop + window.app.sizes.windowHeight;
        const direction = currentScroll > this.prevScroll ? 1 : -1;
        this.prevScroll = currentScroll;

        if (currentScroll > this.endAnimationPoint) {
            if (this.animationState === AnimationStates.after) {
                return;
            }

            if (!app.state.isTopNavDark) {
                app.views.topNav && app.views.topNav.setDarkTheme();
            }
            this.animationState = AnimationStates.after;
            app.vent.trigger(Events.home.tailored.cardTransitionAfter);

            this.$card.addClass(Constants.cssClasses.isHide);

            return;
        }

        if (currentScroll < this.startAnimationPoint) {
            if (this.animationState === AnimationStates.before) {
                return;
            }
            if (app.state.isTopNavDark) {
                app.views.topNav && app.views.topNav.setLightTheme();
            }
            this.animationState = AnimationStates.before;
            app.vent.trigger(Events.home.tailored.cardTransitionBefore);

            this.$card.css({
                transform: ''
            });

            return;
        }


        const progress = scrollTop + window.app.sizes.windowHeight - this.startAnimationPoint;
        const percentage = progress * this.progressCoef;

        const currentRotate = this.startRotate + percentage * (this.maxRotate - this.startRotate);
        const currentScale = this.startScale + percentage * (this.maxScale - this.startScale);
        const currentTranslateX = percentage * this.maxTranslateX;
        if (percentage < 0.5) {
            this.currentPercentageY = progress;
        }
        const currentTranslateY = percentage < 0.5 ? progress : this.currentPercentageY;
        this.$cardItem2.css('opacity', percentage);

        this.$card.css({
            transform: `translate3d(${currentTranslateX}vw, ${currentTranslateY}px, 0)
                                        rotate(${currentRotate}deg)
                                        scale(${currentScale})
                                        ${this.skew}`
        });

        if (percentage > 0.6 && direction === 1 && this.animationState !== AnimationStates.bottomInProgressDown) {
            app.views.topNav && app.views.topNav.setDarkTheme();
            app.vent.trigger(Events.home.tailored.cardTransitionBottomDown);
            this.animationState = AnimationStates.bottomInProgressDown;

            return;
        }

        if (percentage > 0.6 && direction === -1 && this.animationState !== AnimationStates.bottomInProgrerssUp) {
            app.views.topNav && app.views.topNav.setLightTheme();
            this.$card.removeClass(Constants.cssClasses.isHide);

            app.vent.trigger(Events.home.tailored.cardTransitionBottomUp);
            this.animationState = AnimationStates.bottomInProgrerssUp;

            return;
        }

        if (percentage <= 0.6 && direction === -1 && this.animationState !== AnimationStates.inProgress) {
            app.views.topNav && app.views.topNav.setLightTheme();
            this.animationState = AnimationStates.inProgress;
            this.$card.removeClass(Constants.cssClasses.isHide);
            app.vent.trigger(Events.home.tailored.cardTransitionInProgress);
        }
    }
});
